import { useEffect, useState } from 'react';
import Portfolio from './Portfolio';
import { useSolana } from '../../hooks/useSolana';
import { debounce } from 'lodash';

const Dashboard = () => {
  const { refreshTokenBalances } = useSolana();
  const [balancesRefreshed, setBalancesRefreshed] = useState(false);

  useEffect(() => {
    if (!refreshTokenBalances || balancesRefreshed) return;
    const debouncedRefresh = debounce(() => {
      refreshTokenBalances();
      setBalancesRefreshed(true);
    }, 500);
    debouncedRefresh();
    return () => {
      debouncedRefresh.cancel();
    };
  }, [refreshTokenBalances, balancesRefreshed]);

  return (
    <>
      <Portfolio />
    </>
  );
};

export default Dashboard;
